const videos = [
  {
    reg: /^.*(?:(?:v|vi|be|videos|embed)\/(?!videoseries)|(?:v|ci)=)([\w-]{11})/i,
    url: 'https://www.youtube.com/embed/$1',
    poster: 'https://img.youtube.com/vi/$1/maxresdefault.jpg',
    params: {
      'picture-in-picture': 1,
      accelerometer: 1,
      gyroscope: 1
    }
  },
  {
    reg: /^.*vimeo.com\/(\d+)($|\/|\b)/i,
    url: 'https://player.vimeo.com/video/$1',
    params: {
      title: 0,
      byline: 0,
      portrait: 0
    }
  },
  {
    reg: /^.*(?:\/video|dai.ly)\/([A-Za-z0-9]+)([^#&?]*).*/i,
    url: 'https://www.dailymotion.com/embed/video/$1',
    params: {
      autoplay: 0
    }
  },
  {
    reg: /^.*coub.com\/(?:embed|view)\/([A-Za-z0-9]+)([^#&?]*).*/i,
    url: 'https://coub.com/embed/$1',
    params: {
      autoplay: 0
    }
  }
]

export function isVideoEmbed(source) {
  return videos.some(item => item.reg.exec(source))
}

export function videoEmbedAttrs(source, options) {
  const match = videos.find(item => item.reg.exec(source))

  let src = null
  let poster = null

  if (match) {
    const params = Object.assign({}, match.params, options)
    const query = Object.entries(params).map((key, val) => `${key}=${val}`).join('&')
    const and = match.url.indexOf('?') > -1 ? '&' : '?'

    src = source.replace(match.reg, match.url) + and + query

    if (match.poster) {
      poster = source.replace(match.reg, match.poster)
    }
  }

  return { src, poster }
}
